












import CommonBase from "../../CommonBase";
import {Component} from "vue-property-decorator";
import InfectionTraceInfoTxt from "./InfectionTraceInfoTxt.vue";
import rd from "@/modules/vRoutedefs";

@Component({
  components: {
    "at-infect-info-txt": InfectionTraceInfoTxt,
  }
})
export default class InfectionTraceInfoPage extends CommonBase{
  readonly infectionTraceTo = rd.users.reports.infectiontrace.path;
}
